"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var TableBooking = function TableBooking(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "TableBooking"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "table-booking"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.14 1.66h-0.94v1.92h0.94c0 0 0 0 0 0 0.523 0 0.949 0.418 0.96 0.939l0 0.001v11.2c0 1.049-0.851 1.9-1.9 1.9v0h-12.38c-0.006 0-0.013 0-0.020 0-1.049 0-1.9-0.851-1.9-1.9 0-0 0-0 0-0v0-11.2c0.011-0.522 0.437-0.94 0.96-0.94 0 0 0 0 0 0h0.96v-1.92h-0.96c-1.58 0-2.86 1.28-2.86 2.86v0 11.2c0.011 2.101 1.717 3.8 3.82 3.8 0 0 0 0 0 0h12.38c2.094-0.011 3.789-1.706 3.8-3.799v-11.201c0-1.58-1.28-2.86-2.86-2.86v0zM14.28 4.76c0.53 0 0.96-0.43 0.96-0.96v0-2.38c-0.070-0.467-0.469-0.822-0.95-0.822s-0.88 0.354-0.949 0.817l-0.001 0.005v2.38c0 0 0 0 0 0 0 0.523 0.418 0.949 0.939 0.96l0.001 0zM10 4.76c0.53 0 0.96-0.43 0.96-0.96v0-2.38c0-0.53-0.43-0.96-0.96-0.96s-0.96 0.43-0.96 0.96v0 2.38c0 0.53 0.43 0.96 0.96 0.96v0zM5.72 4.76c0.522-0.011 0.94-0.437 0.94-0.96 0-0 0-0 0-0v0-2.38c-0.070-0.467-0.469-0.822-0.95-0.822s-0.88 0.354-0.949 0.817l-0.001 0.005v2.38c0 0.53 0.43 0.96 0.96 0.96v0zM5.16 9.32c-0.174 0.174-0.282 0.414-0.282 0.68s0.108 0.506 0.282 0.68l2.86 2.86c0.173 0.169 0.409 0.272 0.67 0.272s0.497-0.104 0.67-0.273l5.48-5.48c0.174-0.174 0.282-0.414 0.282-0.68s-0.108-0.506-0.282-0.68l-0-0c-0.173-0.169-0.409-0.272-0.67-0.272s-0.497 0.104-0.67 0.273l-4.82 4.82-2.18-2.2c-0.173-0.169-0.409-0.272-0.67-0.272s-0.497 0.104-0.67 0.273l0-0z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = TableBooking;
exports["default"] = _default;